<template>
    <div class="main noTakeaway">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Article :article="review"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'qqjy',
    // meta配置
    metaInfo: {
        title: '【专题】' + '“海风教育”借“轻轻教育”金蝉脱壳？学员反映退款无门',
        meta: [
            {
                name: 'keywords',
                content: '轻轻教育'
            },
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/qqjy/banner.jpg'),
                title: [
                    '“海风教育”借“轻轻教育”金蝉脱壳？学员反映退款无门',
                    ''
                ],
            },

            // 滚动播报
            broadcast: {
                title: {
                    topic: '滚动播报',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                list: [
                    {
                        id: '6599599',
                        title: '【电诉宝】“轻轻教育”被指接盘“海风教育”不排课 用户控诉万元损失谁承担？',
                        post_date: '2021-08-19 10:55:20'
                    },
                    {
                        id: '6598449',
                        title: '【电诉宝】“海风教育”的债“轻轻教育”来偿还？用户控诉近3万元学费无处理',
                        post_date: '2021-07-23 13:56:44'
                    },
                    {
                        id: '6595213',
                        title: '【电诉宝】“海风教育”与“轻轻教育”合并 用户反映剩余课程无法排课',
                        post_date: '2021-06-15 14:40:17'
                    },
                    {
                        id: '6554001',
                        title: '轻轻教育推出六周学习契约 疫情后在线课程比重上升至85%',
                        post_date: ' 2020-04-28 08:46:11'
                    },
                    {
                        id: '6540696',
                        title: '轻轻家教更名轻轻教育 在线授课+上门服务开启业务新探索',
                        post_date: '2020-01-02 08:32:14'
                    },
                ],
            },

            // 相关平台
            review: {
                title: {
                    topic: '相关平台',
                    more: {
                        name: '企业库>',
                        url: 'http://cop.100ec.cn/'
                    }
                },
                nav: [
                    {
                        value: '沪江网校',
                        label: '沪江网校'
                    },
                    {
                        value: '平安好学',
                        label: '平安好学'
                    },
                    {
                        value: '作业帮',
                        label: '作业帮'
                    },
                    {
                        value: '清北网校',
                        label: '清北网校'
                    },
                ],
                params: {
                    p: 1,
                    n: 5,
                    terms: '小叶子智能陪练'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                list: [
                    {
                        body: '/zt/zhkj/',
                        image: '/zt/upload_data/zhkj/images/550.jpg'
                    },
                    {
                        body: '/zt/shjy/',
                        image: '/zt/upload_data/shjy/images/550.jpg'
                    },
                    {
                        body: '/zt/tgjy/',
                        image: '/zt/upload_data/tgjy/images/550.jpg'
                    },
                    {
                        body: '/zt/51talk/',
                        image: '/zt/upload_data/51talk/images/550.jpg'
                    },
                    {
                        body: '/zt/bkw/',
                        image: '/zt/upload_data/bkw/images/550.jpg'
                    },
                    {
                        body: '/zt/yzcjy/',
                        image: '/zt/upload_data/yzcjy/images/550.jpg'
                    },
                ]
            }
        }
    },
}
</script>

<style>

</style>
